/**
 * Sets the page title and favicon based on regionConfig.
 * Call this once at app startup.
 */
import regionConfig from '../config/regionConfig';

export function applyBrandMeta() {
  // Set document title
  document.title = regionConfig.brand.name;

  // Set favicon dynamically for non-BR regions
  if (regionConfig.region !== 'br') {
    try {
      // Dynamic import of the EasyOrder icon
      const iconUrl = require('../img/EasyOrderIcon.png');
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = typeof iconUrl === 'object' ? iconUrl.default : iconUrl;
      }
    } catch (e) {
      console.warn('[BRAND-META] Could not set favicon:', e);
    }
  }
}
